import { Navigate, useLocation } from 'react-router-dom';
import { userAuth } from '../services/userAuth';

export default function CustomerProtectedRoute({ children }) {
  const location = useLocation();
  if (!userAuth.isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
